import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadSpinnerService } from '../services/load-spinner.service';

@Injectable()
export class LoadingSpinnerInterceptor implements HttpInterceptor {

  private totalRequests = 0;

  constructor(
    private LoadSpinnerService: LoadSpinnerService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.totalRequests++;
    this.LoadSpinnerService.setLoading(true);
    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.LoadSpinnerService.setLoading(false);
        }
      })
    );
  }
}